import React, {useState, useEffect} from "react"
import useAreas from "hooks/useAreas"
import {akuzativ} from "utils/utils"
import "./RescueArea.css"

export default function RescueArea(props) {

    const {rescue} = props
    const {mountains} = useAreas()
    const [area, setArea] = useState()
    const [initialized, setInitialized] = useState(false)

    useEffect(() => {
        if (!rescue.ready || initialized) return
        setArea(rescue.rescue.area)
        setInitialized(true)
    }, [rescue.ready])

    useEffect(() => {
        if (!rescue.ready) return
        setArea(rescue.rescue.area)
    }, [rescue.rescue.area])

    useEffect(() => {
        if (!rescue.ready) return
        if (!initialized) return
        rescue.setFields({area})
    }, [area])

    if (!initialized) return

    return <section id="area-report">
        {rescue.isReadOnly ? <div className="read-only">
            {area === '-' ? <>Povredna lista je za OPU akciju</>
                          : <>Povredna lista je u dnevnom izveštaju za {area}</>}
        </div> : <div className="area-pick">
          	<select id="area" value={area} onChange={e => setArea(e.target.value)}>
              	<option value="-">OPU akcija</option>
              	{mountains.map(area => <option key={area} value={area}>Ulazi u dnevni izveštaj za {akuzativ(area)}</option>)}
            </select>
        </div>}
    </section>

}